import { render, staticRenderFns } from "./allNewDetails.vue?vue&type=template&id=46d91152&scoped=true"
import script from "./allNewDetails.vue?vue&type=script&lang=js"
export * from "./allNewDetails.vue?vue&type=script&lang=js"
import style0 from "./allNewDetails.vue?vue&type=style&index=0&id=46d91152&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d91152",
  null
  
)

export default component.exports